module.exports = __webpack_public_path__ + "media/landing_page/landing_page_bg-min-2-df83a480.webp";